import * as React from 'react'
import MUITableHead from '@mui/material/TableHead'

const TableHead = (props) => <MUITableHead {...props} />

export default TableHead
